<template>
  <div>
    <h1>{{ this.projectID }}</h1>
  </div>
</template>
<script>
export default {
  data() {
    return {
      projectID: 0,
    };
  },
  methods: {
    init() {
      let projectID = this.$route.params.projectID;
      this.projectID = projectID;
    },
    BindData() {
      let projectID = this.$route.params.projectID;

      this.$api
        .get("/List/GetPyramidData/", { projectID }, (res) => {})
        .then((res) => {
          if (res.data.status == true) {
          } else {
          }
        });
    },
  },
  mounted() {
    this.init();
    this.BindData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Test.vue